import { graphql } from "react-relay";
import { FeedScheduler } from "./FeedScheduler";
import { TutorialFeedScheduler } from "@components/tutorial-tip";

// TODO: we have the calendarids, so it'd be nice to fetch by id here.
// this will also probably have to be a refetch container
export const feedSchedulerFragments = {
  user: graphql`
    fragment FeedScheduler_user on User {
      id
      emails
      createdTime
      ...TutorialFeedScheduler_user
      chromeExtensionFlagsErrorable {
        __typename
        ... on GraphEntityError {
          statusCode
          message
        }
        ... on Flags {
          flags
        }
      }
      dataSources(first: 1000000) {
        edges {
          node {
            id
            name
            calendarIds
            syncTargets {
              emailAddress
              calendarId
            }
            state
            type
            username
          }
        }
      }
    }
  `,
  org: graphql`
    fragment FeedScheduler_org on Org
    @argumentDefinitions(personCalendarIds: { type: "[String]!", defaultValue: [] }) {
      id
      domains
      primaryOrgEmail
      experiments
      shadowCalendarSettingsErrorable {
        __typename
        ... on ShadowCalendarSettings {
          shadowCalendarId
        }
      }
      personsByCalendarIdsErrorable(calendarIds: $personCalendarIds) {
        __typename
        ... on PersonList {
          list {
            id
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
};

export const refetchQuery = graphql`
  query FeedSchedulerQuery($orgRelayId: ID!, $personCalendarIds: [String]!) {
    org: node(id: $orgRelayId) {
      ... on Org {
        ...FeedScheduler_org @arguments(personCalendarIds: $personCalendarIds)
      }
    }
  }
`;
